import { WebhookEventType } from '@/types/Webhook'
import fetchJson from '@/utils/fetchJson'
import { getReportById } from '@/utils/methods'
import { ReportFilters } from '@/components/Graphs'

type SendManageInternalEventArgs = {
  reportId?: string
  eventType: WebhookEventType
  filters?: ReportFilters
}

export const sendManageInternalEvent = ({
  reportId = '',
  eventType,
  filters = {},
}: SendManageInternalEventArgs) => {
  return fetchJson('/api/manage-internal-event', {
    method: 'POST',
    body: JSON.stringify({
      eventType,
      reportName: getReportById(reportId)?.name,
      reportId,
      filters,
    }),
  })
}
